import{ProductVersion as o}from"@gamezop/gzp-frontend-common/types";const p=p=>o[p]||"gzp-play";export{p as getProductVersion};
